import {
  canShowBySuppressionKey,
  suppressBySuppressionKey,
} from '../../../shared/services/localStorageSuppression';

export const UNFINISHED_ENTRY_PROMPT_KEY =
  'unfinishedEntryPromptSuppressedUntil';

// 表示したら閉じ方に関わらずこの日数は出さない
export const SHOWN_SUPPRESSION_DAYS = 1;

// 「しばらくこのメッセージを表示しない」にチェックして閉じたときの日数
export const CHECKED_SUPPRESSION_DAYS = 14;

/**
 * 抑止期間を過ぎていれば表示できる。
 * プライベートブラウズ等でストレージを読めない場合は未保存として扱う。
 */
export const canShowUnfinishedEntryPrompt = (
  now: Date = new Date(),
): boolean => {
  try {
    return canShowBySuppressionKey(UNFINISHED_ENTRY_PROMPT_KEY, now);
  } catch {
    return true;
  }
};

/**
 * 指定日数だけ表示を止め、止める期限を返す。
 * 保存できない環境でも閉じたあと再表示しないよう、呼び出し側は返した期限をメモリにも持つ。
 */
export const suppressUnfinishedEntryPrompt = (
  days: number,
  now: Date = new Date(),
): Date => {
  try {
    suppressBySuppressionKey(UNFINISHED_ENTRY_PROMPT_KEY, days, now);
  } catch {
    // 保存できなくてもメモリ上の期限で抑止できるので無視する
  }
  // localStorageSuppression と同じ計算で期限を揃える
  const suppressedUntil = new Date(now);
  suppressedUntil.setDate(suppressedUntil.getDate() + days);
  return suppressedUntil;
};
